export const SCROLL_DELAY_ANIMATED = 460;
export const SCROLL_DELAY_INSTANT = 50;

export const scrollToElement = (
  itemId: string,
  delay: number = 300,
  scrollFn?: (id: string) => void,
): void => {
  setTimeout(() => {
    const element = document.getElementById(itemId);
    if (!element) {
      return;
    }
    // Only scroll when the header is not already well-positioned.
    // Skip if header is in the upper 65 % of the viewport (content below is reachable);
    // scroll for above-viewport, below-viewport, or lower-35 % (expanded content cut off).
    const rect = element.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const isHeaderInGoodPosition =
      rect.top >= 0 && rect.top < viewportHeight * 0.65;
    if (!isHeaderInGoodPosition) {
      if (scrollFn) {
        scrollFn(itemId);
      } else if (typeof element.scrollIntoView === 'function') {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, delay);
};
